import SaleSash from './saleSash'

export default SaleSash
